import { useApi, useToast, useWorkspace } from '~/contexts';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PageLoader } from '~/routes/public/pages';

const RETURN_TO = {
  calendar: '/my-profile/calendar',
  connect: '/settings/integrations',
  consent: '/settings/integrations/microsoft',
};

const CONNECTED_RETURN_TO = { ...RETURN_TO, connect: '/settings/integrations/microsoft' };

const CONNECTED = {
  calendar: 'Your Outlook calendar is connected.',
  connect: 'Microsoft 365 is connected.',
  consent: 'Consent granted for your organization.',
};

function MicrosoftCalendarRedirect() {
  const api = useApi();
  const location = useLocation();
  const { navigateWorkspace } = useWorkspace();
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      let data;
      try {
        ({ data } = await api.microsoftCalendar.authorize({ uri: window.location.href }));
      } catch (error) {
        const failure = error?.response?.data ?? {};
        const message = error?.message || 'We could not connect your Outlook calendar. Please try again.';

        if (failure.workspaceKey) {
          toast.error(message);
          await navigateWorkspace(failure.workspaceKey, RETURN_TO[failure.flow] ?? RETURN_TO.calendar);
          return;
        }

        if (error?.status === 401 || error?.status === 403) toast.error('Please sign in and try again.');
        else toast.error(message);
        history.push('/');
        return;
      }

      if (data.connected || data.consented) toast.success(CONNECTED[data.flow] ?? CONNECTED.calendar);
      await navigateWorkspace(data.workspaceKey, CONNECTED_RETURN_TO[data.flow] ?? RETURN_TO.calendar);
    })();
  }, [location.search, api, navigateWorkspace, toast, history]);

  return <PageLoader />;
}

export default MicrosoftCalendarRedirect;
